<div class="effects">
  @if (isBoldAvailable()) {
    <div class="item"
         [class.active]="!!textModel.fontBold"
         (click)="toggleFontVariant('bold')">
      <img [src]="previewUrl('bold')">
    </div>
  }
  @if (isItalicAvailable()) {
    <div class="item"
         [class.active]="!!textModel.fontItalic"
         (click)="toggleFontVariant('italic')">
      <img [src]="previewUrl('italic')">
    </div>
  }
  @for (effect of Object.keys(textModel.effects); track effect) {
    <div class="item"
         [class.active]="textModel.effects[effect]"
         (click)="toggleEffect(effect)">
      <img [src]="previewUrl(effect)">
    </div>
  }
</div>
